import { useEffect, useMemo } from 'react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigation } from '@/context/NavigationContext';
import { useSession } from '@/context/SessionContext';
import { resolveLegacyAccountRoute } from '@/lib/account-routing';

export default function LegacyAccountRedirectPage() {
  const navigation = useNavigation();
  const { session } = useSession();

  const target = useMemo(
    () => resolveLegacyAccountRoute(navigation.path, session?.accountId ?? null),
    [navigation.path, session?.accountId]
  );

  useEffect(() => {
    navigation.navigate(target, { replace: true });
  }, [navigation, target]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Redirecting</CardTitle>
        <CardDescription>
          {target === '/support'
            ? 'Legacy ticket routes now open the tenant-native support stub.'
            : 'Legacy account routes now resolve through the tenant-first portal flow.'}
        </CardDescription>
      </CardHeader>
      <CardContent className="text-sm text-muted-foreground">Opening {target}…</CardContent>
    </Card>
  );
}
